// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Stock_AdjustInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/stock/adjust
 *
 * Manual stock adjustment to an absolute quantity.
 */
import { registerContract } from './validate'

export interface Stock_AdjustInput {
franchise_id: number
product_id: number
quantity: number
notes?: string
so_stock_price?: number
so_stock_minimum_quantity?: number
}

registerContract('Stock_AdjustInput', {
  franchise_id:              { type: 'number',  required: true },
  product_id:                { type: 'number',  required: true },
  quantity:                  { type: 'number',  required: true },
  notes:                     { type: 'string',  required: false },
  so_stock_price:            { type: 'number',  required: false },
  so_stock_minimum_quantity: { type: 'number',  required: false },
})
